import { type ReactNode } from 'react'
import { CompliancePolicyForm, ButtonAdd, Page } from '@components'
import { useAddCompliancePolicy, useProfile, zodResolver } from '@front/model'
import { useToastError } from '@hooks'
import { useForm } from '@mantine/form'
import { showNotification } from '@mantine/notifications'
import { useRouter, createFileRoute } from '@tanstack/react-router'
import { UnsavedCompliancePolicySchema, type UnsavedCompliancePolicy } from '@terros/common'

function AddCompliancePolicy(): ReactNode {
  const router = useRouter()
  const { user } = useProfile()
  const { add, isAdding, error } = useAddCompliancePolicy()
  useToastError(error)

  const form = useForm<UnsavedCompliancePolicy>({
    initialValues: {
      enabled: true,
      title: '',
      criteria: '',
      reportDestinations: user ? [user.email] : [],
    },
    validate: zodResolver(UnsavedCompliancePolicySchema),
  })

  const handleSubmit = async (values: UnsavedCompliancePolicy): Promise<void> => {
    await add(values)
    router.history.back()
    form.resetDirty(values)
    showNotification({ message: 'New Policy Created', color: 'green' })
  }

  return (
    <form onSubmit={form.onSubmit(handleSubmit)}>
      <Page>
        <Page.Heading title='Add Compliance Policy' back>
          <ButtonAdd type='submit' loading={isAdding} disabled={!form.isValid()} />
        </Page.Heading>
        <Page.Content scrollArea>
          <CompliancePolicyForm form={form} />
        </Page.Content>
      </Page>
    </form>
  )
}

export const Route = createFileRoute('/compliance_/policy_/add/')({
  component: AddCompliancePolicy,
})
